import { render } from "./PriezdOtezd.vue?vue&type=template&id=a7ebd11e"
import script from "./PriezdOtezd.vue?vue&type=script&lang=js"
export * from "./PriezdOtezd.vue?vue&type=script&lang=js"

import "./PriezdOtezd.vue?vue&type=style&index=0&id=a7ebd11e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__